import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ChevronDown } from '@wix/wix-ui-icons-common';
import { WixDesignSystemContext } from '../WixDesignSystemProvider/context';
import { dataHooks } from './InputShell.constants';
import { st, classes } from './InputShell.st.css.js';
import Box from '../Box';
/** A wrapper component that has a style of an input component */
const InputShell = (props) => {
    const { newColorsBranding } = useContext(WixDesignSystemContext);
    const { as: Component = 'div', children, menuArrow, dataHook, focused = 'auto', onClick, ...rest } = props;
    return (React.createElement(Component, { ...rest, "data-hook": dataHook, className: st(classes.root, {
            newColorsBranding,
            menuArrow: props.menuArrow,
            disabled: props.as === 'button' ? props.disabled : false,
            focused: String(focused),
        }), onClick: onClick },
        React.createElement("div", { className: st(classes.content) },
            children,
            menuArrow && (React.createElement(Box, { dataHook: dataHooks.menuArrow, className: st(classes.suffix) },
                React.createElement(ChevronDown, null))))));
};
InputShell.displayName = 'InputShell';
InputShell.propTypes = {
    dataHook: PropTypes.string,
    as: PropTypes.oneOf(['div', 'button']),
    menuArrow: PropTypes.bool,
    children: PropTypes.node,
    focused: PropTypes.oneOf([PropTypes.bool, 'auto']),
    disabled: PropTypes.bool,
    tabIndex: PropTypes.number,
    'aria-haspopup': PropTypes.oneOf([
        'menu',
        'listbox',
        'tree',
        'grid',
        'dialog',
        'true',
        'false',
        PropTypes.bool,
    ]),
    'aria-controls': PropTypes.string,
    onClick: PropTypes.func,
};
export default InputShell;
//# sourceMappingURL=InputShell.js.map